import Icon from '../../../components/AppIcon';
import { toArabicDigits } from '../../../utils/numbers';

const CommunityInsights = ({ insights }) => {
  const stats = [
    {
      icon: 'Eye',
      label: 'إجمالي القراءات',
      value: toArabicDigits(insights?.totalReads ?? 0),
      color: '#C5A059',
      bgColor: 'rgba(197, 160, 89, 0.1)'
    },
    {
      icon: 'Clock',
      label: 'متوسط وقت القراءة',
      value: insights?.avgReadTime || '0 دقائق',
      color: '#6B5B47',
      bgColor: 'rgba(107, 91, 71, 0.1)'
    },
    ...(insights?.completionRate != null
      ? [
          {
            icon: 'TrendingUp',
            label: 'معدل الإكمال',
            value: `${toArabicDigits(insights.completionRate)}%`,
            color: '#7D8471',
            bgColor: 'rgba(125, 132, 113, 0.1)'
          }
        ]
      : []),
    {
      icon: 'Share2',
      label: 'المشاركات',
      value: toArabicDigits(insights?.shares ?? 0),
      color: '#B8860B',
      bgColor: 'rgba(184, 134, 11, 0.1)'
    }
  ];

  return (
    <div>
      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
        {stats?.map((stat, index) => (
          <div
            key={index}
            className="rounded-2xl p-6 transition-all duration-300"
          >
            <div
              className="w-12 h-12 rounded-full flex items-center justify-center mb-4"
              style={{ backgroundColor: stat?.bgColor }}
            >
              <Icon name={stat?.icon} size={24} color={stat?.color} />
            </div>
            <p
              className="text-3xl font-bold mb-2"
              style={{
                fontFamily: 'Aref Ruqaa, serif',
                color: stat?.color
              }}
            >
              {stat?.value}
            </p>
            <p
              className="text-sm"
              style={{
                fontFamily: 'Amiri, serif',
                color: '#5A5A5A'
              }}
            >
              {stat?.label}
            </p>
          </div>
        ))}
      </div>

      {/* Engagement Tips */}
      <div
        className="mt-12 rounded-2xl p-8"
      >
        <div className="flex items-start gap-4">
          <div
            className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: 'rgba(197, 160, 89, 0.1)' }}
          >
            <Icon name="Lightbulb" size={24} color="#C5A059" />
          </div>
          <div>
            <h4
              className="text-xl font-bold mb-3"
              style={{
                fontFamily: 'Aref Ruqaa, serif',
                color: '#2C2B29'
              }}
            >
              نصائح للتفاعل الفعال
            </h4>
            <ul className="space-y-2">
              <li
                className="text-base"
                style={{
                  fontFamily: 'Amiri, serif',
                  color: '#5A5A5A',
                  lineHeight: '1.8'
                }}
              >
                • شارك أفكارك بصدق واحترام
              </li>
              <li
                className="text-base"
                style={{
                  fontFamily: 'Amiri, serif',
                  color: '#5A5A5A',
                  lineHeight: '1.8'
                }}
              >
                • استخدم @ للإشارة إلى مستخدمين آخرين في التعليقات
              </li>
              <li
                className="text-base"
                style={{
                  fontFamily: 'Amiri, serif',
                  color: '#5A5A5A',
                  lineHeight: '1.8'
                }}
              >
                • صفق للمقالات التي تلامس قلبك
              </li>
              <li
                className="text-base"
                style={{
                  fontFamily: 'Amiri, serif',
                  color: '#5A5A5A',
                  lineHeight: '1.8'
                }}
              >
                • انضم للمناقشات ذات الصلة لتوسيع آفاقك
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommunityInsights;